import {
  Component,
  Input,
} from '@angular/core';

@Component({
    selector: 'file-img-show-view',
    templateUrl: './file-img-show-view.component.html',
    styleUrls: ['./file-img-show-view.component.scss'],
})
export class FileImgShowViewComponent {
    @Input() url: string = null;

    constructor(){}


}